
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/messages-2"}},[_c('path',{attrs:{"d":"M14.622 13.323l.309 2.5a.788.788 0 01-1.187.776l-3.318-1.969a7.9 7.9 0 01-1.069-.071 3.848 3.848 0 00.934-2.5 4.217 4.217 0 00-4.355-4.076 4.5 4.5 0 00-2.47.72 5.018 5.018 0 01-.03-.597 6.768 6.768 0 016.99-6.523 6.768 6.768 0 016.99 6.523 6.376 6.376 0 01-2.794 5.217z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.291 12.057a3.848 3.848 0 01-.934 2.5 4.421 4.421 0 01-3.42 1.56l-2.066 1.228a.5.5 0 01-.744-.483l.2-1.56a3.949 3.949 0 01-1.744-3.245 3.977 3.977 0 011.884-3.349 4.5 4.5 0 012.47-.72 4.217 4.217 0 014.354 4.069z"}})])])
          )
        }
      }
    